<ph-dialog [open]="open" size="sm" [heading]="heading" [icon]="icon" [noClose]="saving" (ph-close)="close()">
    <ph-stack>
        <ph-file-upload *ngIf="!picked"
                        [accept]="accept"
                        [hint]="hint"
                        [disabled]="saving"
                        (ph-files)="onFiles($event)"></ph-file-upload>

        <ng-container *ngIf="picked">
            <ph-toolbar>
                <ph-avatar *ngIf="avatar; else thumbnail"
                           [size]="avatarSize"
                           [src]="picked.previewUrl"
                           [alt]="picked.file.name"></ph-avatar>
                <ng-template #thumbnail>
                    <ph-file-thumbnail [src]="picked.previewUrl"
                                       [alt]="picked.file.name"
                                       [shape]="shape"
                                       [size]="size"
                                       remove-label="Remove selected image"
                                       [noRemove]="saving"
                                       (ph-remove)="clear()"></ph-file-thumbnail>
                </ng-template>
                <ph-stack gap="snug" align="start">
                    <ph-hint>{{ picked.file.name }}</ph-hint>
                    <ph-link-button *ngIf="avatar" variant="primary" [disabled]="saving" (click)="clear()">Choose a different image</ph-link-button>
                </ph-stack>
            </ph-toolbar>
            <ph-alert *ngIf="picked.underSized" status="warning" variant="lighter">{{ underSizedText }}</ph-alert>
            <ph-hint *ngIf="hint">{{ hint }}</ph-hint>
        </ng-container>

        <ph-alert *ngIf="shownError" status="error" variant="lighter">{{ shownError }}</ph-alert>
    </ph-stack>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" type="button" [disabled]="saving" (click)="close()">Cancel</ph-button>
        <ph-button variant="primary" mode="filled" type="button" [disabled]="!picked" [loading]="saving" (click)="submit()">{{ saveLabel }}</ph-button>
    </ph-actions>
</ph-dialog>
